export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/times-e27f7a254d21c07fe5517324c1a36e56.svg";